import { pageHead } from "@/lib/route-head";
import { createFileRoute } from "@tanstack/react-router";
import { lazy } from "react";
const Contact = lazy(() => import("@/pages/Contact"));

export const Route = createFileRoute("/_public/contact")({
  head: () => pageHead({ path: "/contact", title: "Contact Amorette", description: "Get in touch with the Amorette team about membership, Reservations, billing or partnerships." }),
  component: Contact,
});
